export default __webpack_public_path__ + "static/media/TCWireless.7162b12a.svg";